import animateValue, { updateHeight } from "../utils/animateValue";
import { disableVideo, enableVideo } from "../utils/video";
import Slider from "./slider";

export default function(el) {
    const slider = Slider(el);
    const toggles = Array.from(el.querySelectorAll(".vt__toggle"));
    let activeIdx = null;
    let animationDuration = getComputedStyle(el).getPropertyValue("--vt-a-duration");
    animationDuration = animationDuration ? parseInt(animationDuration.replace(/[^0-9]/g, ""), 10) : null;

    const setActiveIdx = (idx) => (activeIdx = idx);

    const getToggleIdx = (toggle) => parseInt(toggle.dataset.index, 10);

    const toggleItem = (idx, actionType, isTriggeredBySliderControls = false) => {
        const filteredToggles = toggles.filter((t) => getToggleIdx(t) === idx);
        const slide = !isTriggeredBySliderControls && slider && slider.getInfo().slideItems[idx];

        filteredToggles.forEach((t) => {
            t.classList[actionType]("vt__toggle--active");

            if (t.classList.contains("expandable__opener")) {
                const expandableContent = t.nextElementSibling;

                if (expandableContent)
                    animateValue(
                        expandableContent,
                        updateHeight,
                        expandableContent.offsetHeight,
                        actionType === "add" ? expandableContent.scrollHeight : 0,
                        300,
                    );
            }
        });

        if (!slide) return;

        if (actionType === "add") {
            enableVideo(slide);
            slider.goTo(idx);
        } else {
            disableVideo(slide);
        }
    };

    const handleToggleClick = (toggle) => {
        const idx = getToggleIdx(toggle);

        if (!idx === null || (activeIdx !== null && activeIdx === idx)) return;

        toggleItem(activeIdx, "remove");
        toggleItem(idx, "add");
        setActiveIdx(idx);
    };

    const handleToggleTransitionEnd = (toggle, e) => {
        if (e.propertyName !== "transform" || !e.target.classList.contains("vt__indicator") || e.elapsedTime !== animationDuration) return;

        const activeIdx = getToggleIdx(toggle);
        const idx = activeIdx + 1 >= toggles.filter((t) => t.classList.contains("vt__tab")).length ? 0 : activeIdx + 1;

        toggleItem(activeIdx, "remove");
        toggleItem(idx, "add");
        setActiveIdx(idx);
    };

    if (toggles.length === 0) return;

    toggles.forEach((t) => t.addEventListener("click", handleToggleClick.bind(null, t)));
    toggles.forEach((t) => t.addEventListener("transitionend", handleToggleTransitionEnd.bind(null, t)));

    if (slider)
        slider.events.on("indexChanged", (sliderInfo) => {
            toggleItem(sliderInfo.indexCached, "remove", true);
            toggleItem(sliderInfo.index, "add", true);
        });

    toggleItem(0, "add");
    setActiveIdx(0);
}
